const mixins = {}

export const themeOptionFactory = (theme) => ({
  mixins,
  assets: {
    fonts: {
      urls: ["/assets/fonts/one-siam/sukhumvit-set.css"],
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: theme.palette.background.default,
        },
      },
    },
    HomePage: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(5),
          padding: 0,
          height: "100%",
          maxWidth: "320px",
          "@media (min-width: 600px)": {
            padding: 0,
            maxWidth: "320px",
          },
          "&:before": {
            content: "''",
            position: "fixed",
            zIndex: -1,
            width: "249px",
            height: "249px",
            top: "-15px",
            right: "-125px",
            background:
              "transparent url(https://api-directory.siampiwat.com/static/uploads/bubble_1_d4cb851644.png) center/contain no-repeat",
          },
          "&:after": {
            content: "''",
            position: "fixed",
            bottom: "40px",
            opacity: "0.6",
            left: "40px",
            zIndex: -1,
            width: "104px",
            height: "104px",
            background:
              "transparent url(https://api-directory.siampiwat.com/static/uploads/bubble_1_d4cb851644.png) center/contain no-repeat",
          },
        },
        header: {
          padding: theme.spacing(9, 2, 3, 2),
        },
        content: {
          display: "flex",
          flexDirection: "column",
          flex: 1,
          marginTop: "-224px", // header's height + root's gap
          justifyContent: "center",
        },
        logo: {
          height: "79px",
        },
        venueSelectorContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
          padding: theme.spacing(1, 2),
        },
        venueSelectorLabel: {
          fontSize: "0.875rem",
          fotnWeight: 400,
          color: theme.palette.text.secondary,
        },
      },
    },
    AppNavigationBar: {
      styleOverrides: {
        root: {
          display: "flex",
          gap: theme.spacing(1.5),
          flexFlow: "row",
          flexWrap: "wrap",
          width: "100%",
        },
        buttonWrapper: {
          display: "flex",
          justifyContent: "center",
          transition: `background ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn} `,
        },
        icon: {
          width: "100%",
          height: "100%",
          borderRadius: 0,
          "& img": {
            transition: `filter ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn} `,
            objectFit: "contain",
          },
        },
        button: {
          width: "88px",
          height: "88px",
          background: `url(https://api-directory.siampiwat.com/static/uploads/bg_Button_31fbff3950.png)`,
          backgroundSize: "contain",
          backgroundColor: "unset",
          borderRadius: "4px",
          boxShadow: "0px 6px 8px 0px #0000001A",
          padding: theme.spacing(1.75),
          transition: `background ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
          "&.Mui-selected": {
            background: "none",
            ":hover": {
              backgroundColor: "unset",
            },
            "& img": {
              filter: "brightness(0) invert(1)",
            },
          },
        },
      },
    },
  },
})
